// extracted by mini-css-extract-plugin
export default {"rectImage":"RectImage_rectImage__OtlFV"};